import './PayPalButton.css';
import React, { Component } from 'react';
import { logError } from 'Utils/Logger';

export class PayPalButton extends Component {
  async componentDidMount() {
    const { onApprove, onError, onClick, idName } = this.props;

    try {
      const style = { color: 'silver', height: 50, shape: 'pill' };
      const btn = await paypal.Buttons({
        style,
        createOrder: onClick,
        onApprove,
        onError,
        onShippingChange: this.handleShippingChange,
      });
      await btn.render(`#${idName}`);
    } catch (error) {
      logError(error);
    }
  }

  handleShippingChange = (data, { resolve, reject }) => {
    const {
      shipping_address: { country_code: country },
    } = data;
    return country !== 'US' ? reject() : resolve();
  };

  render() {
    return (
      <div id={this.props.idName}>
        <span className="submitButtonText">{this.props.submitButtonText}</span>
      </div>
    );
  }
}
